import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from "react";
const STORAGE_KEY = "itr-agent-theme";
const ThemeContext = createContext(null);
function readInitialTheme() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw === "dark" || raw === "light" || raw === "system")
            return raw;
    }
    catch {
        /* ignore */
    }
    return "system";
}
export const ThemeProvider = ({ children }) => {
    const [theme, setThemeState] = useState(readInitialTheme);
    const [resolvedTheme, setResolvedTheme] = useState("light");
    useLayoutEffect(() => {
        const isDark = theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
        const nextResolved = isDark ? "dark" : "light";
        setResolvedTheme(nextResolved);
        document.documentElement.classList.toggle("dark", nextResolved === "dark");
        try {
            localStorage.setItem(STORAGE_KEY, theme);
        }
        catch {
            /* ignore */
        }
    }, [theme]);
    const setTheme = useCallback((next) => {
        setThemeState(next);
    }, []);
    const toggleTheme = useCallback(() => {
        setThemeState((prev) => {
            if (prev === "light")
                return "dark";
            if (prev === "dark")
                return "system";
            return "light";
        });
    }, []);
    const value = useMemo(() => ({ theme, resolvedTheme, setTheme, toggleTheme }), [theme, resolvedTheme, setTheme, toggleTheme]);
    return _jsx(ThemeContext.Provider, { value: value, children: children });
};
export const useTheme = () => {
    const ctx = useContext(ThemeContext);
    if (!ctx)
        throw new Error("useTheme must be used inside ThemeProvider");
    return ctx;
};
